import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconUnlocked2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconUnlocked2"><Path fillRule="evenodd" clipRule="evenodd" d="M12 1.5C14.1061 1.5 15.8906 2.87007 16.5137 4.76562L15.0879 5.23438C14.6611 3.93603 13.4391 3 12 3C10.2051 3 8.75 4.45507 8.75 6.25V7.23828C9.75341 6.76736 10.8563 6.5 12 6.5C16.2802 6.5 20 10.2198 20 14.5C20 18.7802 16.2802 22.5 12 22.5C7.71979 22.5 4 18.7802 4 14.5C4 11.9685 5.30128 9.63325 7.25 8.14746V6.25C7.25 3.62665 9.37665 1.5 12 1.5ZM11.25 16.75H12.75V11.75H11.25V16.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconUnlocked2;
